"use strict";
export var MinChannelPriorty = 100;
//# sourceMappingURL=IChannelControls.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK.Interfaces/IChannelControls.js
// module id = 597
// module chunks = 42